











































































































import Vue from 'vue'
import { checkIcon } from '@/helper/constants'
import PostMaterialModal from '@/components/common/PostMaterialModal.vue'
import CategoryTreeNode, {
  CategoryTreeNodeType
} from '@/models/CategoryTreeNode'
import { checkNodeIsCompleted } from '@/helper'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'

export default Vue.extend({
  components: {
    PostMaterialModal,
    BaseIcon
  },
  name: 'NeueCategoryPostTree',
  props: {
    categoryTree: {
      type: Array
    },
    level: {
      type: Number,
      default: 0
    },
    available: {
      type: Boolean,
      default: true
    },
    activePost: {
      type: Object
    },
    isBackground: {
      type: Boolean,
      default: true
    },
    highlightBackground: {
      type: String
    },
    completedPosts: {
      type: Set,
      default: new Set()
    },
    postIndexes: {
      type: Map,
      default: new Map()
    },
    active: Object,
    highlightColor: String,
    categoryId: String
  },
  data() {
    return {
      checkIcon,
      showModal: false
    }
  },
  mounted() {
    const categoryContainer = document.querySelector('#category-list') as HTMLElement
    const activePostEl = document.querySelector(`#post__${this.postId}`) as HTMLElement
    if(activePostEl?.offsetTop > categoryContainer?.offsetHeight - 10) {
      categoryContainer.scroll({ top: activePostEl.offsetTop - activePostEl.scrollHeight - (2 * activePostEl.offsetHeight), left: 0, behavior: 'smooth'})
    }
  },
  methods: {
    nodeIsPost(type: CategoryTreeNodeType) {
      return type === CategoryTreeNodeType.Post
    },
    nodeIsCompleted(entity: CategoryTreeNode): boolean {
      return checkNodeIsCompleted(this.completedPosts, entity)
    }
  },
  computed: {
    postId(): string {
      return this.$route.params.post_id
    },
    templateId(): string {
      return this.$route.query.template_id
    }
  }
})
